/*
  Bouton « Voir la vidéo » : ouvre une lightbox et joue la vidéo.

  L'iframe (ou la balise <video>) vit dans un <template> et n'est injectée qu'à l'ouverture.
  Deux raisons : rien ne se charge tant que personne ne clique, et vider le conteneur à la
  fermeture coupe net la lecture, ce qu'un simple masquage ne ferait pas (le son continuerait).
*/
(function () {
  var lastFocus = null;

  function frameOf(modal) { return modal.querySelector('[data-pvb-frame]'); }

  function open(modal) {
    var tpl = modal.querySelector('[data-pvb-embed]');
    var frame = frameOf(modal);
    if (!tpl || !frame) return;

    lastFocus = document.activeElement;
    frame.appendChild(tpl.content.cloneNode(true));
    modal.removeAttribute('hidden');
    document.documentElement.style.overflow = 'hidden';

    var close = modal.querySelector('[data-pvb-close].pvb__close');
    if (close) close.focus();
  }

  function close(modal) {
    modal.setAttribute('hidden', '');
    frameOf(modal).innerHTML = '';           // coupe la lecture
    document.documentElement.style.overflow = '';
    if (lastFocus && lastFocus.focus) lastFocus.focus();
    lastFocus = null;
  }

  document.addEventListener('click', function (e) {
    var trigger = e.target.closest('[data-pvb-open]');
    if (trigger) {
      e.preventDefault();
      var host = trigger.closest('.pvb');
      var modal = host && (host.pvbModal || host.querySelector('[data-pvb-modal]'));
      if (modal) open(modal);
      return;
    }
    var closer = e.target.closest('[data-pvb-close]');
    if (closer) {
      e.preventDefault();
      var m = closer.closest('[data-pvb-modal]');
      if (m) close(m);
    }
  });

  /* Clavier (audit du 20/10/2026) : Échap ferme aussi depuis les commandes du lecteur
     (écoute en phase de capture, avant que la balise video ne garde la touche), et Tab
     tourne dans la fenêtre au lieu de repartir dans la page derrière. */
  var FOCUSABLE = 'button, [href], iframe, video[controls], input, select, textarea, [tabindex]:not([tabindex="-1"])';

  document.addEventListener('keydown', function (e) {
    var open_ = document.querySelector('[data-pvb-modal]:not([hidden])');
    if (!open_) return;
    if (e.key === 'Escape') {
      e.preventDefault();
      close(open_);
      return;
    }
    if (e.key !== 'Tab') return;
    var items = Array.prototype.filter.call(open_.querySelectorAll(FOCUSABLE), function (el) {
      return el.offsetParent !== null || el === document.activeElement;
    });
    if (!items.length) return;
    var first = items[0];
    var last = items[items.length - 1];
    if (!open_.contains(document.activeElement)) {
      e.preventDefault();
      first.focus();
    } else if (e.shiftKey && document.activeElement === first) {
      e.preventDefault();
      last.focus();
    } else if (!e.shiftKey && document.activeElement === last) {
      e.preventDefault();
      first.focus();
    }
  }, true);

  /* Emplacement (21/10/2026, option A choisie par Baptiste) : le bouton quitte la colonne
     d'achat et devient une pastille posée sur la photo principale, là où l'on cherche à
     voir le produit. On déplace tout le conteneur .pvb (bouton ET fenêtre : l'ouverture
     cherche la fenêtre dans le même .pvb). La colonne ne lui réserve déjà plus de place
     (CSS `.js` du snippet), donc le déplacement ne fait rien bouger. Sans JS, le bouton
     reste dans la colonne. */
  function place() {
    var list = document.querySelectorAll('.product-single__meta .pvb');
    for (var i = 0; i < list.length; i++) {
      var pvb = list[i], node = pvb.parentElement, main = null;
      while (node && !main) { main = node.querySelector('.product__main-photos'); node = node.parentElement; }
      if (main) {
        main.classList.add('pvb-host');
        var tools = main.querySelector('.pvb-tools');
        if (!tools) { tools = document.createElement('div'); tools.className = 'pvb-tools'; main.appendChild(tools); }
        tools.appendChild(pvb);
        var trg = pvb.querySelector('[data-pvb-open]');
        if (trg && trg.getAttribute('aria-label')) trg.title = trg.getAttribute('aria-label');
        /* La fenêtre part sous <body> : dans la galerie, elle restait prise dans le
           contexte d'empilement de la photo et les vignettes de couleur ou les flèches
           du carrousel passaient par-dessus (Baptiste, 21/10/2026). */
        var modal = pvb.querySelector('[data-pvb-modal]');
        if (modal) { pvb.pvbModal = modal; document.body.appendChild(modal); }
      }
      else { pvb.classList.add('pvb--inline'); }
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', place); else place();
})();
